import ScreenController from "./controllers/controller.Screen";
import MenusController from "./controllers/controller.Menus";

export function Game() { 
  return (
    <>
      <MenusController />
      <ScreenController />
    </>
  )
}